import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { LoginEntityActions } from '../../store/login-entity/login-entity.actions';
import { selectLoginEntityLoading, selectLoginEntity } from '../../store/login-entity/login-entity.selectors';
import type { Entity } from '../../../core/models/entity.model';

@Component({
  selector: 'app-login-view',
  templateUrl: './login-view.component.html',
  styleUrls: ['./login-view.component.scss'],
  standalone: false
})
export class LoginViewComponent implements OnInit {
  loginEntity$: Observable<Entity>;
  loading$: Observable<boolean>;

  constructor(private store: Store) {
    this.loginEntity$ = this.store.select(selectLoginEntity);
    this.loading$ = this.store.select(selectLoginEntityLoading);
  }

  ngOnInit() {
    this.store.dispatch(LoginEntityActions.get_entity_start());
  }
}
